<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingAccountsWorkspace from '@/views/Banking/Accounts/BankingAccountsWorkspace.vue'

setPageTitle(PageMeta.Banking.Accounts.Title)
definePage({ meta: PageMeta.Banking.Accounts.Meta })
</script>

<template>
  <BankingAccountsWorkspace />
</template>
